import { useQuery } from '@tanstack/react-query';
import { fetchConfig } from 'api/api.utils';
import { EQueryKeys } from 'constants/enums';
import useAxios from 'hooks/useAxios';

import { IApiPerformancePageResponse } from '../AnalyticsApiPerformanceTab.types';

const API_PERFORMANCE_ENDPOINT = '/dashboard/analytics/api-performance';

interface IUseApiPerformanceMetricsParams {
  publisherId?: string;
  month?: string;
}

interface IUseApiPerformanceMetricsResult {
  data?: IApiPerformancePageResponse;
  isLoading: boolean;
}

export const useApiPerformanceMetrics = ({
  publisherId,
  month
}: IUseApiPerformanceMetricsParams): IUseApiPerformanceMetricsResult => {
  const axios = useAxios();

  const fetchApiPerformance = async (): Promise<IApiPerformancePageResponse> => {
    const responseBody: IApiPerformancePageResponse = await axios.get(
      API_PERFORMANCE_ENDPOINT,
      { month }
    );
    return responseBody;
  };

  const apiPerformanceQuery = useQuery<IApiPerformancePageResponse, unknown>({
    ...fetchConfig.general,
    queryKey: [EQueryKeys.API_PERFORMANCE, publisherId, month],
    queryFn: fetchApiPerformance,
    enabled: Boolean(publisherId) && Boolean(month),
    retry: false
  });

  return {
    data: apiPerformanceQuery.data,
    isLoading: apiPerformanceQuery.isLoading
  };
};
